export const FORCE_CHANGE_PASSWORD = "FORCE_CHANGE_PASSWORD";